/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Batch_Subtitle_Export_None_SelectedInputs */



/**
* | output |
* | --- |
* | "No Event Groups or Presets selected." |
*
* @param {Batch_Subtitle_Export_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_subtitle_export_none_selected = /** @type {((inputs?: Batch_Subtitle_Export_None_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Subtitle_Export_None_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun groupe d’événements ou préréglage sélectionné.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es sind keine Ereignisgruppen oder Voreinstellungen ausgewählt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun gruppo di eventi o preset selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группы событий и предустановки не выбраны.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay grupos de eventos ni ajustes preestablecidos seleccionados.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何事件组或预设。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント グループまたはプリセットが選択されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट ग्रुप या प्रीसेट चयनित नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum grupo de eventos ou predefinição selecionado.")
	return /** @type {LocalizedString} */ ("No Event Groups or Presets selected.")
});